module.exports = __webpack_public_path__ + "static/media/299.d2ff333c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/299.svg
// module id = 171
// module chunks = 0